import { useEffect, useRef } from "react";
import { collectAncestorFeatureIds, findMostSevereLeafId, hasProblem } from "./healthTree";
const useHealthAutoSelection = (tree, root, viewMode, { isRootSelected, hasReport, deepLinked }) => {
  const appliedViewModeRef = useRef(null);
  const topProblemRef = useRef(void 0);
  useEffect(() => {
    if (!hasReport) return;
    const isInitial = appliedViewModeRef.current === null;
    const topProblem = hasProblem(root) ? findMostSevereLeafId(root) : void 0;
    const viewModeChanged = appliedViewModeRef.current !== viewMode;
    const problemSurfacedOnOverview = isRootSelected && topProblem !== topProblemRef.current;
    appliedViewModeRef.current = viewMode;
    topProblemRef.current = topProblem;
    if (isInitial && deepLinked) return;
    if (topProblem && (viewModeChanged || problemSurfacedOnOverview)) {
      collectAncestorFeatureIds(root, topProblem).forEach((id) => tree.expand(id));
      tree.select(topProblem);
    }
  });
};
export default useHealthAutoSelection;
